import {DBConfig} from 'ngx-indexed-db';

export const indexeddbConfig: DBConfig  = {
  name: '7minutespourtoi',
  version: 10,
  objectStoresMeta: [{
    store: 'leads',
    storeConfig: { keyPath: 'id', autoIncrement: false },
    storeSchema: [
      { name: 'createdAt', keypath: 'createdAt', options: { unique: false }},
      { name: 'phone', keypath: 'phone', options: { unique: false }},
      { name: 'sessionId', keypath: 'sessionId', options: { unique: false }},
      { name: 'sex', keypath: 'sex', options: { unique: false }},
      { name: 'age', keypath: 'age', options: { unique: false }},
      { name: 'firstname', keypath: 'firstname', options: { unique: false }},
      { name: 'email', keypath: 'email', options: { unique: false }},
      { name: 'animationCityId', keypath: 'animationCityId', options: { unique: false }},
      { name: 'animationCityName', keypath: 'animationCityId', options: { unique: false }},
      { name: 'desiredAgeMin', keypath: 'ageMin', options: { unique: false }},
      { name: 'desiredAgeMax', keypath: 'ageMin', options: { unique: false }},
      { name: 'myProfile', keypath: 'myProfile', options: { unique: false }},
      { name: 'offer', keypath: 'offer', options: { unique: false }},
      { name: 'options', keypath: 'options', options: { unique: false }},
      { name: 'price', keypath: 'price', options: { unique: false }},
      { name: 'balance', keypath: 'balance', options: { unique: false }},
      { name: 'discountCode', keypath: 'discountCode', options: { unique: false }},
      { name: 'subscription', keypath: 'subscription', options: { unique: false }},
    ]
  }]
};
